import { useEffect } from 'react'
import axios from '@fs/zion-axios'
import { chatApiBase } from '../global/chatConfig'

// Fetches the domain whitelist from the chat API
const useFetchWhitelist = ({ setDomainWhitelist, isOpen, isTransitioning }) => {
  useEffect(() => {
    let isUnmounted = false

    const fetchWhitelist = async () => {
      const url = `${chatApiBase}/whitelist`
      const { data } = await axios.get(url)
      if (!isUnmounted) {
        setDomainWhitelist(data?.results)
      }
    }
    if (isOpen && !isTransitioning) {
      fetchWhitelist()
    }

    return () => {
      isUnmounted = true
    }
  }, [setDomainWhitelist, isOpen, isTransitioning])
}

export default useFetchWhitelist
